export enum TypeIndexDocumentEnum {
  FrontAtpve = 1,
  BackAtpve,
  PdfDocument,
}
